export default "__VITE_ASSET__Cc3ISB7d__"